import { useState, useMemo } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, tryError } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { CircleDot, Loader2, ArrowLeft, KeyRound } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => params.get("token") || "", [params]);
  const initialEmail = useMemo(() => params.get("email") || "", [params]);
  const [email, setEmail] = useState(initialEmail);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw !== pw2) {
      setError("Şifreler eşleşmiyor");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { email: email.trim(), token, new_password: pw });
      navigate("/login?reset=1");
    } catch (err) {
      setError(tryError(err) || "Sıfırlama başarısız.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-foreground text-background flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-background text-foreground rounded-sm border border-border p-8" data-testid="reset-page">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-10 w-10 rounded-sm bg-foreground flex items-center justify-center">
            <CircleDot className="h-6 w-6 text-amber-500" />
          </div>
          <div className="font-display font-black text-xl tracking-tighter">LASTİK OTELİ</div>
        </div>
        <form onSubmit={onSubmit} className="space-y-4" data-testid="reset-form">
          <div className="flex items-center gap-2">
            <KeyRound className="h-5 w-5 text-amber-600" />
            <h2 className="font-display font-black text-2xl tracking-tighter">Yeni Şifre</h2>
          </div>
          <p className="text-sm text-muted-foreground">Yeni şifrenizi belirleyin.</p>
          <div className="space-y-1.5">
            <Label className="label-eyebrow">E-posta</Label>
            <Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-sm h-11" data-testid="reset-email" />
          </div>
          <div className="space-y-1.5">
            <Label className="label-eyebrow">Yeni Şifre</Label>
            <Input required minLength={6} type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="rounded-sm h-11" data-testid="reset-pw" />
          </div>
          <div className="space-y-1.5">
            <Label className="label-eyebrow">Yeni Şifre (Tekrar)</Label>
            <Input required minLength={6} type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="rounded-sm h-11" data-testid="reset-pw2" />
          </div>
          {!token && <div className="text-xs text-destructive">Token bulunamadı. Bağlantınızı kontrol edin.</div>}
          {error && <div className="border-l-2 border-destructive bg-destructive/10 px-4 py-3 text-sm text-destructive">{error}</div>}
          <Button type="submit" disabled={submitting || !token} className="w-full h-12 rounded-sm bg-foreground text-background hover:bg-foreground/90" data-testid="reset-submit">
            {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : "Şifreyi Güncelle"}
          </Button>
          <Link to="/login" className="flex items-center justify-center gap-1 text-sm text-muted-foreground hover:text-foreground">
            <ArrowLeft className="h-3.5 w-3.5" /> Girişe Dön
          </Link>
        </form>
      </div>
    </div>
  );
}
